import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9a31518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-node-col" }
const _hoisted_2 = { class: "flex-node-col input-form-content" }
const _hoisted_3 = {
  class: "flex-container-row align-center gap20",
  style: {"padding":"0 var(--shadow-clearance) var(--shadow-clearance)","margin-top":"var(--margin-body)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "buttons", {}, undefined, true),
      _createVNode(_component_k_button, {
        class: "button-green",
        style: {"margin-left":"auto"},
        disabled: false,
        onClick: _ctx.onSubmit,
        icon: "email"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.submitText), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}